import { makeStyles } from '@mui/styles'
const useStylesModalMenuUserOfSuscriber = makeStyles(() => ({
  hoverButton: {
    cursor: 'pointer',
    color: '#706E6F',
    '&:hover': {
      color: '#026873'
    }
  },
  hoverButtonRotate: {
    cursor: 'pointer',
    color: '#706E6F',
    transform: 'rotate(180deg)',
    '&:hover': {
      color: '#026873'
    }
  },
  stepperStyle: {
    width: 500,

    '@media all and (max-width: 800px)': {
      width: '400px'
    },
    '@media all and (max-width: 600px)': {
      width: '300px'
    },
    '@media all and (max-width: 400px)': {
      width: '100%'
    }
  },
  stepperStyleSeeMore: {
    width: 800,
    '@media all and (max-width: 800px)': {
      width: '600px'
    },
    '@media all and (max-width: 600px)': {
      width: '400px'
    },
    '@media all and (max-width: 400px)': {
      width: '100%'
    }
  },
  typographyStyle: {
    fontSize: 15,
    fontWeight: 700,
    textDecoration: 'none',
    width: 200,
    textAlign: 'start',
    marginLeft: '10%',
    '@media all and (max-width: 800px)': {
      fontSize: 14
    },
    '@media all and (max-width: 600px)': {
      fontSize: 13
    },
    '@media all and (max-width: 400px)': {
      fontSize: 13
    }
  },
  boxTypography: {
    width: '100%',
    display: 'flex',
    marginLeft: '10%'
  },
  boxStyle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    '@media all and (max-width: 800px)': {
      width: '80%'
    },
    '@media all and (max-width: 600px)': {
      width: '70%'
    },
    '@media all and (max-width: 400px)': {
      width: '80%'
    }
  }
}))

export default useStylesModalMenuUserOfSuscriber
